import * as React from "react";
import { cn } from "@utils/utils";

export interface BetaProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const Beta = React.forwardRef<HTMLDivElement, BetaProps>(
  ({ className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "inline-flex items-center gap-2 rounded-full bg-sky-200 px-4 py-2 font-bold text-teal-800",
          className
        )}
        {...props}
      >
        <span className="text-xl font-bold leading-none">β</span>
        <span className="text-sm">Versión Beta</span>
      </div>
    );
  }
);

Beta.displayName = "Beta";

export { Beta };
